<template>
	<div>
    <div class="clearfix"></div>
    <div class="banner" @click="handleCloseMenu">
	    <white-menu ref="whiteMenu"></white-menu>
			<b-container fluid class="section section-lg">
				<b-row class="flex-column">
					<div class="sell-title">SELL YOUR WATCH</div>
					<div class="step" v-show="step == 1">
						<div class="d-flex">
							<div class="circle bg-dark text-white">1</div>
							<div class="contact">Contact</div>
						</div>
						<div class="line"><div class="content"></div></div>
						<div>
							<div class="circle cursor-pointer" @click="handleStep(2)">2</div>
						</div>
					</div>
					<div class="step" v-show="step == 2">
						<div class="d-flex">
							<div class="circle cursor-pointer" @click="handleStep(1)">1</div>
						</div>
						<div class="line-second"><div class="content-second"></div></div>
						<div class="d-flex line-selected">
							<div class="circle bg-dark text-white">2</div>
							<div class="contact">Watch Details</div>
						</div>
					</div>
				</b-row>
				<b-form>
					<!-- step 1 -->
					<b-row class="flex-column contact-content" v-show="step == 1">
						<div class="title">
							<div class="contact">Contact</div>
							<div class="line-body">
								<div class="triangle-left"></div>
								<div class="line"></div>
								<div class="triangle-right"></div>
							</div>
						</div>
						<div class="form-content">
							<b-row class="form-row">
								<b-col class="form-col">
									<b-form-group
										id="input-group-1"
										label="First Name*"
										labelClass="text-left"
										label-for="input-1"
									>
										<b-form-input
											id="input-1"
											v-model="form.firstName"
											type="text"
											placeholder=""
											required
										></b-form-input>
									</b-form-group>
								</b-col>
								<b-col>
									<b-form-group
										id="input-group-2"
										label="Last Name*"
										labelClass="text-left"
										label-for="input-2"
									>
										<b-form-input
											id="input-2"
											v-model="form.lastName"
											type="text"
											placeholder=""
											required
										></b-form-input>
									</b-form-group>
								</b-col>
							</b-row>
							<b-row class="form-row">
								<b-col class="form-col">
									<b-form-group
										id="input-group-3"
										label="Email*"
										labelClass="text-left"
										label-for="input-3"
									>
										<b-form-input
											id="input-3"
											v-model="form.email"
											type="text"
											placeholder=""
											required
										></b-form-input>
									</b-form-group>
								</b-col>
								<b-col>
									<b-form-group
										id="input-group-4"
										label="Country*"
										labelClass="text-left"
										label-for="input-4"
									>
										<b-form-select
											id="input-4"
											v-model="form.country"
											type="text"
											placeholder=""
											required
										></b-form-select>
									</b-form-group>
								</b-col>
							</b-row>
							<b-row class="form-row">
								<b-col class="form-col">
									<b-form-group
										id="input-group-5"
										label="Phone Number*"
										labelClass="text-left"
										label-for="input-5"
									>
										<b-input-group>
											<template #prepend>
												<b-dropdown>
													<template #button-content>
														<span><img src="../../public/img/viawatch/icon/aomen.png"></span>
														<span>（+852）</span>
													</template>
													<b-dropdown-item>
														<span><img src="../../public/img/viawatch/icon/aomen.png"></span>
														<span>（+852）</span>
													</b-dropdown-item>
													<b-dropdown-item>
														<span><img src="../../public/img/viawatch/icon/aomen.png"></span>
														<span>（+852）</span>
													</b-dropdown-item>
												</b-dropdown>
											</template>
											<b-form-input
												id="input-5"
												v-model="form.mobile"
												type="tel"
												placeholder=""
												required
											></b-form-input>
										</b-input-group>
									</b-form-group>
								</b-col>
								<b-col></b-col>
							</b-row>
						</div>
						<div class="data-secure">
							<div class="card">
								<div class="card-body">
									<div class="card-title">
										<div class="card-title-img"><img src=""/></div>
										<div class="card-title-content">Your data is secure</div>
									</div>
									<div class="card-content">
										<div>ViaWatch strictly adheres to all applicable data protection laws.</div>
										<div>All data that you enter on our website is encrypted (SSL) and transmitted
													over a secure Internet connection (HTTPS).</div>
										<div>Your personal information will never be published and is only used during
													the registration process and when selling items on</div>
										<div>ViaWatch.</div>
									</div>
								</div>
							</div>
							<div class="next-step">
								<b-row class="next-step-body">
									<b-col cols="7"></b-col>
									<b-col cols="5">
										<b-button variant="dark" block @click="handleStep(2)">Next Step</b-button>
									</b-col>
								</b-row>
							</div>
						</div>
					</b-row>

					<!-- step 2 -->
					<b-row class="flex-column contact-content" v-show="step == 2">
						<div class="title">
							<div class="contact">Watch r</div>
							<div class="line-body">
								<div class="triangle-left"></div>
								<div class="line"></div>
								<div class="triangle-right"></div>
							</div>
						</div>
						<!-- good info -->
						<div class="form-content">
							<b-row class="form-row">
								<b-col class="form-col">
									<div class="d-block">
										<b-form-group
											id="input-group-6"
											label="Brand*"
											labelClass="text-left font-weight-bold"
											label-for="input-6"
										>
											<b-form-select
												id="input-6"
												v-model="form.brand"
												type="text"
												placeholder=""
												required
											></b-form-select>
										</b-form-group>
									</div>
									<div class="d-block pt-2">
										<b-form-group
											id="input-group-7"
											label="Model"
											labelClass="text-left font-weight-bold"
											label-for="input-7"
										>
											<b-form-select
												id="input-7"
												v-model="form.model"
												type="text"
												placeholder=""
												required
											></b-form-select>
										</b-form-group>
									</div>
									<div class="d-block pt-2">
										<b-form-group
											id="input-group-8"
											label="Reference Number"
											labelClass="text-left font-weight-bold"
											label-for="input-8"
										>
											<b-form-select
												id="input-8"
												v-model="form.referenceNumber"
												type="text"
												placeholder=""
												required
											></b-form-select>
										</b-form-group>
									</div>
									<div class="d-block pt-2">
										<b-form-group
											id="input-group-9"
											label="Condition"
											labelClass="text-left font-weight-bold"
											label-for="input-9"
										>
											<template #label>
												Condition
												<span class="h5 ml-1" v-b-popover.hover.bottom="'Popover!'">
													<b-icon icon="info-circle-fill" aria-hidden="true"></b-icon>
												</span>
											</template>
											<b-form-select
												id="input-9"
												v-model="form.condition"
												type="text"
												placeholder=""
												required
											></b-form-select>
										</b-form-group>
									</div>
									<div class="d-block pt-2">
										<b-form-group label="Do you have original box and papers? Please check all that apply." labelClass="text-left">
											<b-form-checkbox-group
												id="checkbox-group-1"
												v-model="form.packWays"
												:options="packWays"
												name="packWays"
											></b-form-checkbox-group>
										</b-form-group>
									</div>
								</b-col>
								<b-col class="form-col pl-4">
									<div class="d-flex">
										<label class="font-weight-bold">
											Add Photo*
											<span class="h5 ml-1 mb-1" v-b-popover.hover.bottom="'Popover!'">
												<b-icon icon="info-circle-fill" aria-hidden="true"></b-icon>
											</span>
										</label>
									</div>
									<div class="d-flex flex-column photo-text">
										<div class="d-flex"><small>
											Photo of the watch from the <strong>Front, Back,and Side</strong> are necessary.
										</small></div>
										<div class="d-flex"><small>
											The more photos you include, the more accurate your valuation will be.
										</small></div>
									</div>
									<div class="d-flex mt-4">
										<div class="photo-area" @click="handleUploadClick" @drop.prevent="addFile" @dragover.prevent>
											<b-row class="justify-content-between">
												<div class="p-3"><img :src="goodFront" style="width: 10rem;" alt=""></div>
												<div class="p-3"><img :src="goodFront" style="width: 10rem;" alt=""></div>
											</b-row>
											<b-row class="flex-column">
												<div class="mb-2"><img src="../../public/img/viawatch/icon/Img_box_light.png" alt=""></div>
												<div>Select files or drag and drop.</div>
												<input type="file" ref="photoes" class="d-none" multiple accept="image/*" @change="handleFiles">
											</b-row>
											<b-row class="justify-content-between">
												<div class="p-3"><img :src="goodFront" style="width: 10rem;" alt=""></div>
												<div class="p-3"><img :src="goodFront" style="width: 10rem;" alt=""></div>
											</b-row>
										</div>
									</div>
								</b-col>
							</b-row>
						</div>

						<div>
							<div class="line-body">
								<div class="triangle-left"></div>
								<div class="line"></div>
								<div class="triangle-right"></div>
							</div>
						</div>

						<!-- good price -->
						<div class="form-content">
							<b-row class="form-row">
								<b-col class="form-col">
									<div class="d-block pt-3">
										<b-form-group
											id="input-group-10"
											label="What is your asking price?"
											labelClass="text-left font-weight-bold"
											label-for="input-10"
										>
											<b-input-group>
												<template #append>
													<b-dropdown variant="secondary">
														<template #button-content>
															<span> H K D </span>
														</template>
														<b-dropdown-item>
															<span> H K D </span>
														</b-dropdown-item>
														<b-dropdown-item>
															<span> R M B </span>
														</b-dropdown-item>
													</b-dropdown>
												</template>
												<b-form-input
													id="input-10"
													v-model="form.askPrice"
													type="text"
													placeholder=""
													></b-form-input>
											</b-input-group>
										</b-form-group>
									</div>
								</b-col>
								<b-col class="form-col pl-4"></b-col>
							</b-row>
							<b-row class="form-row">
								<b-col class="form-col">
									<div class="d-block text-left font-weight-bold pt-2">
										<label for="input-11">Comments</label>
										<b-form-textarea
											id="input-11"
											placeholder="Tell us about your watch. For example, age, service history, or any other relevant details."
											rows="6"
											no-resize
										></b-form-textarea>
									</div>
								</b-col>
							</b-row>
						</div>

						<div>
							<div class="line-body">
								<div class="triangle-left"></div>
								<div class="line"></div>
								<div class="triangle-right"></div>
							</div>
						</div>

						<!-- add watch -->
						<div class="form-content">
							<b-row class="form-row">
								<b-col class="form-col">
									<div class="d-flex flex-column text-left pt-2">
										<label class="font-weight-bold">Have more than one watch to sell?</label>
										<div class="d-flex mt-2">
											<div class="d-flex align-items-center ml-3 cursor-pointer">
												<span class="h3">
													<b-icon icon="plus-circle-fill" aria-hidden="true"></b-icon>
												</span>
											</div>
											<div class="d-flex align-items-center pl-3 mb-1 text-decoration-underline cursor-pointer">
												Add Watch
											</div>
										</div>
									</div>
								</b-col>
							</b-row>
						</div>

						<div>
							<div class="line-body">
								<div class="triangle-left"></div>
								<div class="line"></div>
								<div class="triangle-right"></div>
							</div>
						</div>
						<!-- submit -->
						<div class="submit-body">
							<b-row>
								<b-col cols="3" class="back-step">
                  <div class="back-step-stick" @click="handleStep(1)">
                    <div class="back-step-arrow"></div>
                    <div class="back-step-text">Back to Step 1</div>
                  </div>
								</b-col>
								<b-col cols="4"></b-col>
								<b-col cols="5">
									<b-button variant="dark" block>SUBMIT</b-button>
								</b-col>
							</b-row>
						</div>

					</b-row>

				</b-form>
			</b-container>
    </div>
  </div>
</template>

<script>
import WhiteMenu from "@/components/WhiteMenu";
export default {
	name: "SellView",
	components: {
		WhiteMenu,
	},
	data() {
		return {
			step: 1,
			form: {
				firstName: undefined,
				lastName: undefined,
				email: undefined,
				country: undefined,
				mobile: undefined,
				brand: undefined,
				model: undefined,
				referenceNumber: undefined,
				condition: undefined,
				packWays: [],
				askPrice: undefined,
				comments: undefined,
				goodPhotoes:[],
			},
			packWays: [
				{text: 'Paper', value: 1},
				{text: 'Box', value: 2},
			],
			goodFront: undefined,
		}
	},
	methods: {
    handleCloseMenu(event) {
      var sp = document.getElementById("headMenu")
      if (!sp.contains(event.target)) {
      	this.$refs.whiteMenu.searchFocus = false;
      	this.$refs.whiteMenu.isHovered = false;
      }
    },
		handleStep(val) {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      document.pageYOffset = 0;
			this.step = val;
		},
		handleFiles(e) {
			const files = e.target.files;
			this.readFiles(files);
		},
		handleUploadClick() {
			this.$refs.photoes.click();
		},
		addFile(e) {
			var my = this.form.goodPhotoes;
			let files = e.dataTransfer.files;
			// [...files].forEach(file => {
			// 	this.form.goodPhotoes.push(file)
			// 	console.log(this.form.goodPhotoes)
			// })
			this.readFiles(files);
		},
		// 参考：https://blog.csdn.net/Little_Fishs/article/details/115302566
		readFiles(files) {
			if (!files || files.length <= 0) {
				return;
			}
			for (const file of files) {
				const url = window.URL.createObjectURL(file);
				// 这里img加src可直接预览图片
				this.goodFront = url;
				const obj = {
					title: file.name.replace(/(.*\/)*([^.]+).*/ig, '$2'), // 去掉文件后缀
					url,
					file,
					fileType: file.type,
					status: 0,  // 状态 -> 0 等待中，1 完成，2 正在上传，3 上传失败
					percent: 0, // 上传进度
				}
				this.form.goodPhotoes.unshift(obj);
				this.$emit('fileList', this.form.goodPhotoes);
			}
		}
	}
}
</script>

<style scoped>
	.sell-title {
		font-size: 32px;
		font-weight: 250;
		margin-top: 50px;
		text-align: center;
	}
	.step {
		display: flex;
		justify-content: center;
		margin-top: 25px;
		margin-bottom: 50px;
	}
	.step .line-selected {
		padding-right: 40px;
	}
	.step .line {
		width: 126px;
		display: flex;
		align-items: center;
	}
	.step .line .content {
		width: 126px;
		border-top: 1px solid black;
	}
	.step .line-second {
		width: 40px;
		display: flex;
		align-items: center;
	}
	.step .line-second .content-second {
		width: 40px;
		border-top: 1px solid black;
	}
	.step .circle {
		display: flex;
		justify-content: center;
		align-items: center;
		width: 49px;
		height: 49px;
		border-radius: 50%;
		border: 1px solid black;
		font-size: 21px;
	}
	.step .contact {
		display: flex;
		align-items: center;
		padding: 0 10px;
	}
	.cursor-pointer {
		cursor: pointer;
	}
	.contact-content {
		margin: 18px 300px;
	}
	.contact-content .title {
		display: flex;
		justify-content: flex-start;
		flex-basis: 100%;
		flex-direction: column;
		margin-bottom: 10px;
	}
	.contact-content .contact {
		display: flex;
		justify-content: flex-start;
		font-size: 36px;
	}
	.contact-content .line-body {
		height: 1px;
		display: flex;
	}
	.contact-content .line {
		height: 1px;
		background: #969696;
		display: flex;
		flex-basis: 100%;
		margin-top: 3.3px;
		margin-left: -8px;
		margin-right: -8px;
	}
	.contact-content .triangle-left {
		width: 0;
		height: 0;
		border: 5px solid;
		border-color: transparent transparent transparent #969696;
	}
	.contact-content .triangle-right {
		width: 0;
		height: 0;
		border: 5px solid;
		border-color: transparent #969696 transparent transparent;
	}
	.form-content {
		padding: 1rem 2rem;
	}
	.form-content .form-control {
		border: 1px solid black;
	}
	.form-content .form-row {
		padding-top: 1rem;
	}
	.form-content .form-row .form-col {
		padding-right: 1.8rem;
	}
	.form-content .custom-select {
		border: 1px solid black;
		background: #fff url("../../public/img/viawatch/icon/pull-bottom.png") no-repeat right 0.75rem center;
	}
	.form-content #input-5 {
		border: none;
	}
	.form-content .input-group {
		border: 1px solid black;
	}
	.form-content #checkbox-group-1 {
		display: flex;
		margin-left: 2rem;
		margin-top: 1rem;
	}
	.form-content .custom-control-label {
		background-color: black;
	}
	.form-content .custom-control-label::before {
		border: 1px solid black;
	}
	.data-secure {
		padding: 1rem 1.4rem;
	}
	.data-secure .card {
		border: 1px solid black;
		font-size: 20px;
		color: black;
		font-weight: 500;
	}
	.data-secure .card .card-body {
		padding: 2rem 3.5rem;
	}
	.data-secure .card-title {
		display: flex;
		margin-bottom: 1.75rem;
	}
	.data-secure .card-title-img {
		width: 52px;
		height: 52px;
		background-color: #D9D9D9;
	}
	.data-secure .card-title-content {
		display: flex;
		justify-content: flex-start;
		align-items: flex-end;
		margin-left: 1.4rem;
	}
	.data-secure .card-content {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
	}
	.next-step {
		display: flex;
		justify-content: flex-end;
		margin: 4.4rem 0;
		padding-bottom: 1rem;
	}
	.next-step .next-step-body {
		flex-basis: 100%;
		font-size: 20px;
	}
	.next-step .btn {
		padding: 0.4rem 1rem;
		font-size: 20px;
	}
	.photo-text small {
		font-size: 95%;
	}
	.photo-area {
		display: flex;
		flex-direction: column;
		flex-basis: 100%;
		height: 22rem;
		justify-content: center;
		align-items: center;
		border: 2px dashed #030303;
		background: #E2EAFA;
	}
	.form-content #input-10 {
		border: none;
		outline: none;
	}
	.form-content #input-group-10 .input-group-append .btn {
		width: 10rem;
	}
	.form-content #input-11 {
		padding: 1.5rem 2rem;
	}
	.form-content .text-decoration-underline {
		text-decoration: underline;
	}
	.submit-body {
		padding-top: 3.6rem;
		font-size: 20px;
	}
	.submit-body .btn {
		padding: 0.4rem 1rem;
		font-size: 20px;
	}
	.submit-body .back-step {
		display: flex;
		align-items: center;
	}
  .submit-body .back-step-arrow {
    position: absolute;
    margin-top: 20px;
    margin-left: 3px;
    width: 20px;
    height: 20px;
    /* border-bottom: 10px solid red; */
    border-left: 2px solid black;
    transform: rotate(45deg);
  }
  .submit-body .back-step-stick {
    position: relative;
    margin-left: 1rem;
    border-bottom: 2px solid black;
    padding-right: 1rem;
    cursor: default;
  }
  .submit-body .back-step-text {
    padding-left: 2rem;
  }
</style>



// WEBPACK FOOTER //
// src/views/SellView.vue